import { Image } from "react-bootstrap";

const PreparingFilesToastMessage = () => {
    return (
        <div className="row align-items-center">
            <div className="col-9 body-small">
                Look for the red dot next to the "file download" button to download all your forms
                once they are ready.
            </div>
            <div className="col-3">
                <Image src="/download-icons-notification.svg" />
            </div>
        </div>
    );
};

export default PreparingFilesToastMessage;
